import { isANumber } from './helpers';

export const fractionAggFunc = (params: { values: any[] }): number | null => {
    if (params.values.length === 1) {
        const value = params.values[0];
        return isANumber(value) ? value : null;
    }
    return null;
};
